/** Platform detection helpers — small and dependency-free. */

export const isIOS = () =>
  typeof navigator !== "undefined" &&
  /iPad|iPhone|iPod/.test(navigator.userAgent || "") &&
  !window.MSStream;

export const isStandalonePWA = () => {
  if (typeof window === "undefined") return false;
  const displayStandalone = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  const iosStandalone = window.navigator.standalone === true; // iOS-specific
  return !!(displayStandalone || iosStandalone);
};

/** Push is only supported in specific contexts:
 *  - Modern desktop browsers
 *  - Android Chrome
 *  - iOS 16.4+ AS AN INSTALLED PWA (not in Safari browser tab)
 */
export const pushSupported = () => {
  if (typeof window === "undefined") return false;
  if (!("serviceWorker" in navigator)) return false;
  if (!("PushManager" in window)) return false;
  if (typeof Notification === "undefined") return false;
  // On iOS, push only works inside the installed PWA (Add to Home Screen).
  if (isIOS() && !isStandalonePWA()) return false;
  return true;
};

/** Are we running in a browser tab on iOS (needs Add to Home Screen first)? */
export const needsIOSInstall = () => isIOS() && !isStandalonePWA();

export const isAndroid = () =>
  typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent || "");

/** Rough mobile detection — used to decide whether to show install prompts. */
export const isMobile = () => {
  if (typeof navigator === "undefined") return false;
  const uaMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || "");
  // Coarse-pointer + narrow viewport catches DevTools emulation and cases where
  // the UA is spoofed (some in-app browsers).
  const coarse = typeof window !== "undefined" && window.matchMedia
    ? window.matchMedia("(pointer: coarse)").matches
    : false;
  const narrow = typeof window !== "undefined" && window.innerWidth <= 820;
  return uaMobile || (coarse && narrow);
};
